export const en = {
    subject: `Confirm your account`,
    title: `Confirm your account`,
    message: `Please click the button below to confirm your account.`,
    button: `Confirm Account`,
    link: `If the button above does not work, copy and paste this link into your browser:`,
    thanks: `Thank you!`,
    text: `Please click on the following link to confirm your account:\n\n{{confirmUrl}}\n\nThank you!`,
    success: `Account confirmed successfully! You can now sign in.`,
};
//# sourceMappingURL=en.js.map